/**
 * @packageDocumentation
 * @module      ConsoleLogger.ts
 * @description Logger utility class to have a uniform structure in logs printed on the console
 * @copyright   Copyright (c) 2025 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class ConsoleLogger {
    static log(...args) {
        const currentTime = (new Date()).toLocaleTimeString();
        let logMessage = currentTime;
        console.log(`[${logMessage}]`, ...args);
    }
}
//# sourceMappingURL=ConsoleLogger.js.map